export default "__VITE_ASSET__CfkKqzzV__"